export enum TitleStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const TitleStatusOptions = [
  {
    label: "Active",
    value: TitleStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: TitleStatus.INACTIVE,
  },
];
